angular.module('app').controller('UndefinedRefererModalController',['$scope','parameters','config', function($scope,parameters,config) {
    $scope.inputValueLength='';
    $scope.checkExternalid = function() {
      $scope.error='';
      $scope.inputValueLength=$scope.externalid.length;
      var regex=new RegExp(parameters.FFO[$scope.ffo].field11);
      if(regex.test($scope.externalid)) {
        $scope.$close({'externalid':$scope.externalid,'partner':config.exists('partner')?config.get('partner'):null});
      } else {
        $scope.formError=true;
      }
    };
}]);
